import GamepageTemplate from "../components/containers/GamepageTemplate";

const NitroStream = () =>{
    return(
        <GamepageTemplate 
            backgroundPng={"nitrostream"}
            gameTitle={"Burnin' Rubber NitroStream"}
            gameDescription={"The greatest street racing event, the NitroStream championship, is live"}
            embedYouTubeId={"iDrzZ73d4G4?si=28svE_F_bMDHy39-"}
            downloadPath={"https://www.mediafire.com/file/f0nsle3g7kablpb/BR+NitroStream+(By+Mars).rar/file"}
            gameVersion={"2.0"}
            versionDate={"2022-09"}
            endOfSupportDate={"2024-01-11"}
        />  
    );
};

export default NitroStream;